/**
 * Document Reference Component
 */

import type { DocumentReference as DocRef } from '@bsp-chatbot/shared';

interface DocumentReferenceProps {
  reference: DocRef;
}

export function DocumentReference({ reference }: DocumentReferenceProps) {
  // Determine document type color
  const getTypeColor = (id: string) => {
    if (id.startsWith('SOP')) return 'bg-blue-100 text-blue-700 border-blue-200';
    if (id.startsWith('WKI')) return 'bg-green-100 text-green-700 border-green-200';
    if (id.startsWith('TMP')) return 'bg-purple-100 text-purple-700 border-purple-200';
    if (id.startsWith('FRM')) return 'bg-orange-100 text-orange-700 border-orange-200';
    if (id.startsWith('GDL')) return 'bg-teal-100 text-teal-700 border-teal-200';
    return 'bg-gray-100 text-gray-700 border-gray-200';
  };

  const getTypeIcon = (id: string) => {
    if (id.startsWith('SOP')) return '📋';
    if (id.startsWith('WKI')) return '📝';
    if (id.startsWith('TMP')) return '📊';
    if (id.startsWith('FRM')) return '📄';
    if (id.startsWith('GDL')) return '📖';
    return '📁';
  };

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full border ${getTypeColor(
        reference.documentId
      )}`}
      title={reference.title}
    >
      <span>{getTypeIcon(reference.documentId)}</span>
      <span>{reference.documentId}</span>
      {reference.section && (
        <span className="opacity-75">({reference.section})</span>
      )}
    </span>
  );
}
